// Keyed-hash blind indexes for exact lookup on encrypted values (SECURITY.md §3).
// index key = HKDF-SHA256(clinic data key, info "klinixis/index/v1")
import { b64url, utf8, buf } from './encoding';

export async function deriveIndexKey(clinicKeyRaw: Uint8Array): Promise<CryptoKey> {
  const base = await crypto.subtle.importKey('raw', buf(clinicKeyRaw), 'HKDF', false, ['deriveKey']);
  return crypto.subtle.deriveKey(
    { name: 'HKDF', hash: 'SHA-256', salt: new ArrayBuffer(0), info: buf(utf8.encode('klinixis/index/v1')) },
    base,
    { name: 'HMAC', hash: 'SHA-256', length: 256 },
    false,
    ['sign'],
  );
}

export async function blindIndex(indexKey: CryptoKey, kind: 'phone' | 'nrc' | 'name', canonical: string): Promise<string> {
  const mac = await crypto.subtle.sign('HMAC', indexKey, buf(utf8.encode(`${kind}:${canonical}`)));
  return b64url(new Uint8Array(mac));
}
